export const CHART_WIDTH = 120;
export const ARC_STROKE_WIDTH = 10;
export const ARC_START_COORDINATES = { x: 60, y: 60 };
export const CIRCLE_ANGLE = 360;
